module.exports = __webpack_public_path__ + "img/prestige-privilege-inactive@3x-en.png";